var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUUserPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 16,
    fill: "#FEBF15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 19C16.4297 19.5741 16.9776 20.0491 17.6067 20.3929C18.2359 20.7367 18.9317 20.9411 19.6468 20.9923C20.362 21.0435 21.0798 20.9403 21.7515 20.6897C22.4233 20.4392 23.0333 20.047 23.5402 19.54L26.5402 16.54C27.451 15.597 27.955 14.3339 27.9436 13.023C27.9322 11.712 27.4063 10.4579 26.4793 9.53087C25.5523 8.60383 24.2982 8.07799 22.9872 8.0666C21.6762 8.0552 20.4132 8.55918 19.4702 9.46997L17.7502 11.18M20.0002 17C19.5707 16.4258 19.0228 15.9508 18.3936 15.607C17.7645 15.2633 17.0687 15.0588 16.3535 15.0076C15.6384 14.9564 14.9206 15.0596 14.2489 15.3102C13.5771 15.5608 12.9671 15.9529 12.4602 16.46L9.4602 19.46C8.54941 20.403 8.04544 21.666 8.05683 22.977C8.06822 24.288 8.59407 25.542 9.52111 26.4691C10.4481 27.3961 11.7022 27.9219 13.0132 27.9333C14.3242 27.9447 15.5872 27.4408 16.5302 26.53L18.2402 24.82",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUUserPlus);
export default __webpack_public_path__ + "static/media/u_user-plus.1564d83dc0005ed41b10aaa50c9d2a89.svg";
export { ForwardRef as ReactComponent };